// API URL configuration
// Автоматическое определение окружения (как в firebase.js)
// Note: isDevelopment is not currently used but kept for future reference

// Production API URL
const PROD_API_URL = 'https://backend-237397542353.europe-central2.run.app';

// API URL - использует продакшн URL по умолчанию
// Можно переопределить через переменную окружения REACT_APP_API_URL
export const API_URL = process.env.REACT_APP_API_URL || PROD_API_URL;

export const MAP_API_URL = process.env.REACT_APP_MAP_API_URL;
export const TEST_API_URL = process.env.REACT_APP_TEST_API_URL || PROD_API_URL;

// Monitoring service URL
const PROD_MONITORING_URL = 'https://monitoring-service-237397542353.us-central1.run.app';
export const MONITORING_API_URL = process.env.REACT_APP_MONITORING_API_URL || PROD_MONITORING_URL;

// Логирование для отладки removed